import {ILogger} from "../domain/iLogger";
import {LogLevel} from "../../config/domain/logLevel";

export class ConsoleLogger implements ILogger {
    public constructor(private project: string, private logLevel?: LogLevel) {
    }

    public log(message: any): void;
    public log(...message: any[]): void;
    public log(...args: any[]): void {
        if (this.logLevel && ['log'].includes(this.logLevel)) {
            console.log(`[${this.project}]`, ...args);
        }
    }

    public warn(message: any): void;
    public warn(...message: any[]): void;
    public warn(...args: any[]): void {
        if (this.logLevel && ['log', 'warn'].includes(this.logLevel)) {
            console.warn(`[${this.project}]`, ...args);
        }
    }

    public error(message: any): void;
    public error(...message: any[]): void;
    public error(...args: any[]): void {
        if (this.logLevel && ['log', 'warn', 'error'].includes(this.logLevel)) {
            console.error(`[${this.project}]`, ...args);
        }
    }
}
